import { useState, useEffect } from 'react';
import { getPlayerAvatar } from '../../utils/player';
import ModalCloseButton from './ModalCloseButton';

/** Match setup for classic singles/doubles (Figma 787:16668, selected 787:16758). */
const BestOfSetsModal = ({
  bestOfSets,
  onBestOfChange,
  sessionStartingPlayers = [],
  allPlayers = [],
  onConfirm,
  onCancel,
}) => {
  const [orderedPlayers, setOrderedPlayers] = useState(sessionStartingPlayers);
  const [selectedSwapIdx, setSelectedSwapIdx] = useState(null);

  useEffect(() => {
    setOrderedPlayers(sessionStartingPlayers);
  }, [sessionStartingPlayers]);

  const handlePlayerClick = (index) => {
    if (selectedSwapIdx === null) {
      setSelectedSwapIdx(index);
    } else if (selectedSwapIdx === index) {
      setSelectedSwapIdx(null);
    } else {
      const nextPlayers = [...orderedPlayers];
      const temp = nextPlayers[selectedSwapIdx];
      nextPlayers[selectedSwapIdx] = nextPlayers[index];
      nextPlayers[index] = temp;
      setOrderedPlayers(nextPlayers);
      setSelectedSwapIdx(null);
    }
  };

  const isSingles = orderedPlayers.length === 2;
  const isDoubles = orderedPlayers.length === 4;
  const teamSize = isDoubles ? 2 : 1;

  const renderPlayer = (playerObj, idx) => {
    const name = typeof playerObj === 'object' ? playerObj.name : playerObj;
    const isSelected = selectedSwapIdx === idx;
    return (
      <button
        key={name || idx}
        type="button"
        onClick={() => handlePlayerClick(idx)}
        aria-pressed={isSelected}
        className={`match-setup-player${isSelected ? ' is-selected' : ''}`}
      >
        <img src={getPlayerAvatar(allPlayers, name)} alt="" className="avatar match-setup-avatar" />
        <span className="match-setup-name">{name}</span>
      </button>
    );
  };

  return (
    <div className="modal-overlay">
      <div className="modal match-setup" role="dialog" aria-modal="true" aria-labelledby="match-setup-title">
        <ModalCloseButton onClick={onCancel} />
        <h3 id="match-setup-title" className="modal-title">
          {isSingles ? 'Singles' : 'Doubles'}
        </h3>

        {/* TEAMS & SWAP UI */}
        {(isDoubles || isSingles) && (
          <>
            <p className="match-setup-hint">Tap 2 players to swap teams</p>
            <div className="match-setup-players">
              {orderedPlayers.slice(0, teamSize).map((p, i) => renderPlayer(p, i))}
              <span className="match-setup-vs">vs</span>
              {orderedPlayers.slice(teamSize, teamSize * 2).map((p, i) => renderPlayer(p, i + teamSize))}
            </div>
          </>
        )}

        {/* BEST OF SETS */}
        <p id="match-setup-sets" className="match-setup-question">How many sets do you want to play?</p>
        <div className="match-setup-sets" role="group" aria-labelledby="match-setup-sets">
          {[1, 3].map((n) => (
            <button
              key={n}
              type="button"
              onClick={() => onBestOfChange(n)}
              aria-pressed={bestOfSets === n}
              aria-label={`Best of ${n} ${n === 1 ? 'set' : 'sets'}`}
              className={`btn match-setup-set${bestOfSets === n ? ' is-selected' : ''}`}
            >
              {n}
            </button>
          ))}
        </div>

        <button
          type="button"
          onClick={() => onConfirm(orderedPlayers)}
          className="btn btn-primary btn-full match-setup-start"
        >
          <span className="btn-text">START MATCH</span>
        </button>
      </div>
    </div>
  );
};

export default BestOfSetsModal;
